import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import React, { createContext } from "react";

export interface IProductDataContext {
  product?: IProductPageResponse.IPdpProduct;
  brand?: IProductPageResponse.IPdpBrand;
}

export const ProductDataContext = createContext<IProductDataContext>({});

export const ProductDataProvider: React.FC<
  React.PropsWithChildren<IProductDataContext>
> = ({ product, brand, children }) => (
  <ProductDataContext.Provider value={{ product, brand }}>
    {children}
  </ProductDataContext.Provider>
);
